<ng-container *transloco="let t; prefix: 'financing.stepper-section'">
  <div class="grid grid-cols-1 md:grid-cols-2 gap-14">
    <div class="max-w-[460px]">
      <h3 class="text-black rfs:text-4xl mb-6">
        {{ t("title") }}
      </h3>
    </div>
    <div
      class="pt-12 pl-8 md:pl-12 rounded-[24px] flex md:flex-row flex-col justify-between">
        <div class="flow-root pb-4 pr-4">
          <ul role="list" class="-mb-8 max-w-[546px]">
            @for (step of steps; track step; let i = $index) {
            <li class="cursor-pointer" (click)="setActive(i)">
              <div class="relative pb-10">
                @if (i !== steps.length - 1) {
                <span
                  class="absolute left-6 top-4 -ml-px h-full w-0.5 bg-gray-200"
                  aria-hidden="true"
                ></span>
                }
                <div class="relative flex space-x-3">
                  <div>
                    <span
                      class="flex h-12 w-12 font-semibold text-2xl transition-all items-center justify-center rounded-full ring-8 ring-gray-50"
                      [ngClass]="{
                          'bg-[#0BC582] text-black ring-1 ring-[#0BC582]': step.active === true,
                          'text-gray-900 bg-white': step.active === false,
                        }"
                    >
                      {{ i + 1 }}
                    </span>
                  </div>
                  <div>
                    <div
                      class="flex min-w-0 flex-1 justify-between space-x-4 pt-1.5"
                    >
                      <div
                        class="text-lg transition-all"
                        [ngClass]="{
                            'text-[#7E8797]': !step.active,
                            'text-black font-semibold': step.active,
                          }"
                      >
                        {{ t(step.title) }}
                      </div>
                    </div>
                    @if (step.active === true) {
                    <div>
                      {{ t(step.description) }}
                    </div>
                    }
                  </div>
                </div>
              </div>
            </li>
            }
          </ul>
        </div>
    </div>
  </div>
  <!-- <div class="mb-10">
    <h3 class="text-black rfs:text-4xl mb-6">
      {{ t("title") }}
    </h3>
  </div>
  <div
    class="pt-12 pl-8 md:pl-12 bg-white rounded-[24px] flex md:flex-row flex-col justify-between"
  >
    <div class="flow-root pb-4 pr-4">
      <ul role="list" class="-mb-8 max-w-[546px]">
        @for (step of steps; track step; let i = $index) {
        <li class="cursor-pointer" (click)="setActive(i)">
          <div class="relative pb-10">
            @if (i !== steps.length - 1) {
            <span
              class="absolute left-6 top-4 -ml-px h-full w-0.5 bg-gray-200"
              aria-hidden="true"
            ></span>
            }
            <div class="relative flex space-x-3">
              <div>
                <span
                  class="flex h-12 w-12 font-semibold text-2xl transition-all items-center justify-center rounded-full ring-8 ring-white"
                  [ngClass]="{
                      'bg-[#0BC582] text-black': step.active === true,
                      'text-gray-900 bg-gray-100': step.active === false,
                    }"
                >
                  {{ i + 1 }}
                </span>
              </div>
              <div>
                <div
                  class="flex min-w-0 flex-1 justify-between space-x-4 pt-1.5"
                >
                  <div
                    class="text-lg transition-all"
                    [ngClass]="{
                        'text-[#7E8797]': !step.active,
                        'text-black font-semibold': step.active,
                      }"
                  >
                    {{ t(step.title) }}
                  </div>
                </div>
                @if (step.active === true) {
                <div>
                  {{ t(step.description) }}
                </div>
                }
              </div>
            </div>
          </div>
        </li>
        }
      </ul>
    </div>
  </div> -->
</ng-container>
